import styled from "@emotion/styled";
import { useIsTesting } from "@yuno/dashboard-container-mfe";
import { Box, Theme, Typography } from "@yuno/design-system-web";
import { Header } from "./header";
import { Sidebar } from "./sidebar";

const Content = styled(Box)<{ isTesting?: boolean; theme?: Theme }>`
  display: flex;
  height: ${({ isTesting }) => (isTesting ? "84.05vh" : "88.1vh")};
  background: ${({ theme }) => theme.palette.grey[1]};
`;

const Body = styled.div<{ scrollable?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  overflow-y: ${({ scrollable }) => (scrollable ? "auto" : "hidden")};
`;

export const Layout = ({ children, scrollable = true }) => {
  const { isTesting } = useIsTesting();

  return (
    <>
      <Header />
      <Content isTesting={isTesting}>
        <Sidebar />
        <Body scrollable={scrollable}>{children}</Body>
      </Content>
    </>
  );
};
